<template>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          elevation="3"
          :to="elements.route"
          dark
          block 
          v-bind="attrs"
          v-on="on"
        >
          <v-icon left>{{elements.icon}}</v-icon>
          {{elements.text}}
        </v-btn>
      </template>
      <span>{{elements.tooltip}}</span>
    </v-tooltip>
</template>
<script>
export default {
    name: 'btnAccion',
    props:{
        elements: Object
    },
    data: ()=>({

    }),
    beforeMount() {
      this.check();
    },
    methods:{
      check(){
        if(!this.elements.color){
          Object.assign(this.elements, {color:"primary"})
        }
      }
    }
}
</script>